import { AxiosResponse } from 'axios';
import { apiClient, getAuthHeaders } from './index';

export interface TokenAlert {
  id: string;
  tokenAddress: string;
  description: string;
  type: string;
  value: unknown;
  created_at: Date;
  updated_at: Date;
}

export const tokenAlertApi = {
  /**
   * Get all token alerts by token address
   * @param tokenAddress 토큰 주소
   * @returns Token Alert 목록
   */
  async getTokenAlerts(tokenAddress: string): Promise<TokenAlert[]> {
    try {
      const response: AxiosResponse<any> = await apiClient.get(
        `/fe-management-system/token-alerts/${tokenAddress}`,
        {
          headers: getAuthHeaders(),
        }
      );

      return response.data.data || [];
    } catch (error: any) {
      console.error('❌ GET /fe-management-system/token-alerts/{tokenAddress} 에러:', error);
      throw error;
    }
  },
};
